import React from 'react';

import TextInputFormik, { TextInputFormikProps } from './TextInputFormik';

const LETTERS_REGEX = /^[a-zA-Z]*$/;

export type LettersInputProps = Omit<TextInputFormikProps, 'allowedRegex'>;

/**
 * A text input for letters only.
 */
const LettersInput: React.FC<LettersInputProps> = ({ ...props }) => {
  return <TextInputFormik {...props} allowedRegex={LETTERS_REGEX} />;
};

export default LettersInput;
